/* IP-only purchase return links. No referral attribution or cross-store history. */
(function() {
  'use strict';
  var key = 'ip:purchase-return:v1';
  var maxAge = 3 * 60 * 60 * 1000;
  var marker = document.querySelector('[data-ip-navigation-context]');
  if (!marker) return;
  var page = marker.dataset.ipPage;

  // Only known storefront routes and useful selection/filter parameters survive.
  // In particular, never persist admin/draft preview credentials or external URLs.
  function route(value, kind) {
    if (!value) return '';
    try {
      var url = new URL(value, window.location.origin);
      if (url.origin !== window.location.origin || url.username || url.password) return '';
      if (/%2f|%5c|%2e|\\/i.test(url.pathname)) return '';
      var match = url.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2})?)?\/(products|collections)\/([^/]+)(?:\/([^/]+))?\/?$/i);
      if (!match || (kind && match[1] !== kind)) return '';
      if (match[1] === 'products' && match[3]) return '';
      if (match[1] === 'collections' && /^(all|frontpage)$/i.test(match[2])) return '';
      var query = new URLSearchParams();
      if (match[1] === 'products') {
        var variant = url.searchParams.get('variant');
        if (variant && /^\d+$/.test(variant)) query.set('variant', variant);
      } else {
        url.searchParams.forEach(function(value, name) {
          if (name === 'page' && /^\d+$/.test(value) || name === 'sort_by' || name.indexOf('filter.') === 0) query.append(name, value);
        });
      }
      return url.pathname + (query.size ? '?' + query.toString() : '');
    } catch (error) { return ''; }
  }

  function read() {
    try {
      var saved = JSON.parse(window.sessionStorage.getItem(key));
      var age = Date.now() - Number(saved && saved.at);
      if (!saved || !Number.isFinite(age) || age < 0 || age > maxAge) return null;
      var url = route(saved.url);
      return url ? { url: url, collection: route(saved.collection, 'collections') } : null;
    } catch (error) { return null; }
  }

  function save(value) {
    if (!value || !value.url) return;
    try { window.sessionStorage.setItem(key, JSON.stringify({ url: value.url, collection: value.collection || '', at: Date.now() })); }
    catch (error) { /* Navigation must work when browser storage is unavailable. */ }
  }

  var previous = read();
  // Forget a removed/unpublished product after it actually returned a 404.
  if (page === '404' && previous && previous.url.split('?')[0] === window.location.pathname) {
    previous = null;
    try { window.sessionStorage.removeItem(key); } catch (error) { /* Optional storage. */ }
  }
  var productPath = route(marker.dataset.ipProductUrl, 'products');
  var collectionPath = route(marker.dataset.ipCollectionUrl, 'collections');
  var referrer = route(document.referrer);
  var current = null;
  if (page === 'product' && productPath) {
    if (!collectionPath) collectionPath = route(referrer, 'collections');
    if (!collectionPath && previous && previous.url.split('?')[0] === productPath) collectionPath = previous.collection;
    var variant = marker.dataset.ipVariant;
    current = { url: productPath + (variant && /^\d+$/.test(variant) ? '?variant=' + variant : ''), collection: collectionPath };
  } else if (page === 'collection' && collectionPath) {
    var locationPath = route(window.location.href, 'collections');
    current = { url: locationPath || collectionPath };
  }
  save(current);

  function update() {
    document.querySelectorAll('[data-ip-return-link]').forEach(function(link) {
      // Referral pages always return to the referrer page the server chose.
      if (link.dataset.ipReturnMode === 'fixed') return;
      var target = '';
      if (link.dataset.ipReturnMode === 'collection') {
        target = collectionPath;
      } else {
        // A referrer URL alone is not proof that a product page existed.
        target = (current && current.url) || (previous && previous.url) || '';
      }
      // A missing product must not send a visitor straight back to the same 404.
      if (page === '404' && target.split('?')[0] === window.location.pathname) target = '';
      if (!target) {
        // A cached page can outlive its saved product (expiry or a later 404).
        // Restore the server-rendered fallback instead of leaving a stale link.
        var fallback = (current && current.url) || link.dataset.ipReturnFallback;
        if (fallback && link.getAttribute('href') !== fallback) link.setAttribute('href', fallback);
        if (link.dataset.ipReturnLabel && link.textContent !== link.dataset.ipReturnLabel) link.textContent = link.dataset.ipReturnLabel;
        if (link.dataset.ipReturnHide === 'true') link.setAttribute('hidden', '');
        return;
      }
      var label = route(target, 'collections') ? '前に見ていた商品一覧に戻る' : '前に見ていた商品に戻る';
      if (link.getAttribute('href') !== target) link.setAttribute('href', target);
      if (link.textContent !== label) link.textContent = label;
      link.removeAttribute('hidden');
    });
  }
  update();
  window.addEventListener('pageshow', function() {
    previous = read();
    update();
  });
  document.addEventListener('variantChange', function(event) {
    if (!current || page !== 'product') return;
    var variant = event.detail && event.detail.variant;
    var id = variant && String(variant.id);
    current.url = productPath + (id && /^\d+$/.test(id) ? '?variant=' + id : '');
    save(current);
    document.querySelectorAll('[data-ip-return-mode="collection"]').forEach(function(link) {
      if (!collectionPath) link.setAttribute('href', current.url);
    });
  });
  // Cart section replacement and theme-editor reloads can insert new controls.
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(function(records) {
      if (records.some(function(record) {
        return Array.from(record.addedNodes).some(function(node) {
          return node.nodeType === 1 && (node.matches('[data-ip-return-link]') || node.querySelector('[data-ip-return-link]'));
        });
      })) update();
    }).observe(document.body, { childList: true, subtree: true });
  }
})();
